// Docs at https://tanstack.com/router/latest/docs/framework/react/guide/custom-link

import { createLink } from '@tanstack/react-router';
import { Link as ReactAriaLink } from 'react-aria-components';
import { MenuItemStyled } from '@moonjellydigital/react-components';

export const Link = createLink(ReactAriaLink);
export const MenuItemLink = createLink(MenuItemStyled);
